import { useTranslation } from "react-i18next";

const Translation = (Parameter) => {
  const { t } = useTranslation();
  const langMsg = Parameter.Key;
  return t(langMsg);
};
export default Translation;